import { SelectItemAdditionalParams } from '../../hooks/bi/useTrackItemSelectAnalytics/types';
import { MediaManagerSDKAnyItem, MediaManagerSDKFolder } from '../../media-manager-sdk';

export enum JumpTo {
  Next,
  Prev,
  Bottom,
  Top,
}

export type TEntities = {
  items?: { [key: string]: MediaManagerSDKAnyItem };
};

export interface IItemsReducer {
  items: MediaManagerSDKAnyItem[];
  isLoading: boolean;
  selectedItems: MediaManagerSDKAnyItem[];
  selectedItemsCount: number;
  editingItem: MediaManagerSDKAnyItem;
  hasSelectedItems: boolean;
  isSingleItemSelected: boolean;
  hasNoItems: boolean;
}

export type TState = {
  entities: TEntities;
  items: string[];
  isLoading: boolean;
  selectedItems: string[];
  lastSelectedItems: string[];
  lastSelectedItemId: string;
  editingItem: MediaManagerSDKAnyItem;
  newFolderId: string;
};

export enum ItemsAction {
  Reset = 'reset',

  AppendItems = 'append-items',
  PrependItems = 'prepend-items',
  InsertAfterFolders = 'insert-after-folders',
  RemoveItems = 'remove-items',

  ClearAll = 'clear-all',
  ClearItemsSelection = 'clear-items-selection',

  SelectItems = 'select-items',
  SelectItemsUntil = 'select-items-until',

  EditItemCancel = 'edit-item-cancel',
  EditItemStart = 'edit-item-start',
  EditItemComplete = 'edit-item-complete',
  UpdateEditingItem = 'update-editing-item',

  UpdateLocalItem = 'update-local-item',

  AddItemToSelection = 'add-item-to-selection',
  RemoveItemFromSelection = 'remove-item-from-selection',

  JumpToNextItem = 'jump-to-next-item',

  CreateNewFolderStart = 'create-new-folder-start',
  CreateNewFolderCancel = 'create-new-folder-cancel',
  CreateNewFolderComplete = 'create-new-folder-complete',
}

export type TUpdatedItem = {
  id?: string;
  name?: string;
  labels?: string[];
};

export type TItemsReducerAction = {
  type: ItemsAction;
  payload?: {
    itemId?: string;
    itemIds?: string[];
    newFolderId?: string;
    item?: MediaManagerSDKAnyItem;
    items?: MediaManagerSDKAnyItem[];
    isLoading?: boolean;
    updatedItem?: TUpdatedItem;
    isInExpandedMode?: boolean;
    shouldSelectNextItem?: boolean;
    withShift?: boolean;
    jumpTo?: JumpTo;
    itemForPreview?: MediaManagerSDKAnyItem;
  };
};

export interface IWithItemsReducerOuter {
  fileType: string;
  items: MediaManagerSDKAnyItem[];
  nextPageItems: MediaManagerSDKAnyItem[];
}

export type TToggleItemSelection = (itemId: string, params?: Partial<SelectItemAdditionalParams>) => void;

export interface IWithItemsReducerInner extends IItemsReducer {
  selectItem: (itemId: string, params?: object) => void;
  selectItems(itemIds: string[]): void;
  selectItemsUntil(itemId: string): void;
  prependItems: (items: MediaManagerSDKAnyItem[]) => void;
  removeItems(items: MediaManagerSDKAnyItem[]): void;
  updateLocalItem: (itemId: string, item: Partial<MediaManagerSDKAnyItem>) => void;
  updateEditingItem(item: Partial<MediaManagerSDKAnyItem>): void;
  clearItemsSelection(): void;
  createNewFolderStart(id: string): void;
  isItemSelected(id: string): boolean;
  isItemEditing(id: string): boolean;
  insertAfterFolders(items: MediaManagerSDKAnyItem[]): void;
  toggleItemSelection: TToggleItemSelection;
  createNewFolderComplete(folder: MediaManagerSDKFolder): void;
  createNewFolderCancel(): void;
  editItemComplete(): void;
}
